import { Link } from 'react-router-dom';
import { categories, siteConfig } from '@/mocks/home';

export default function CategoryNav() {
  return (
    <section className="bg-background-100 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-8 text-center">
          吃瓜导航
        </h2>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-4 md:p-5 rounded-2xl bg-background-50 hover:bg-accent-100/30 transition-colors duration-200 group"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 rounded-xl bg-accent-100 flex items-center justify-center group-hover:bg-accent-500 transition-colors duration-300">
                <i className={`${cat.icon} text-accent-600 group-hover:text-background-50 text-lg md:text-xl transition-colors duration-300`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 text-center whitespace-nowrap">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}